import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  AddRounded as AddRoundedIcon,
  PushPinOutlined as PushPinOutlinedIcon,
  PushPinRounded as PushPinRoundedIcon,
} from '@mui/icons-material';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';

// Shared Typography variants carry -0.4px tracking; the card title in the design
// has none. The description keeps it, so only the title overrides.
const TITLE_STYLE = { letterSpacing: 0 };

const FeatureCard = ({
  image,
  title,
  description,
  isPinned = false,
  isMenuOpen = false,
  onTogglePin,
  onAdd,
}) => {
  const { t } = useTranslation();
  const PinIcon = isPinned ? PushPinRoundedIcon : PushPinOutlinedIcon;

  return (
    <div
      className={`feature-card${isPinned ? ' pinned' : ''}${
        isMenuOpen ? ' active' : ''
      }`}
    >
      <div className="feature-artwork">
        <img className="feature-image" src={image} alt={title} />

        <div className="feature-hover">
          <button
            type="button"
            className="feature-add"
            onClick={onAdd}
            aria-label={title}
          >
            <AddRoundedIcon className="feature-add-icon" />
          </button>
        </div>

        <button
          type="button"
          className="feature-pin"
          onClick={onTogglePin}
          aria-label={
            isPinned ? t('educatorsFeatureUnpin') : t('educatorsFeaturePin')
          }
        >
          <PinIcon className="feature-pin-icon" />
        </button>
      </div>

      <div className="feature-info">
        <Typography
          variant="body-16-semibold"
          color={COLOR.label2[100]}
          style={TITLE_STYLE}
        >
          {title}
        </Typography>
        <Typography variant="body-12-regular" color={COLOR.label2[64]}>
          {description}
        </Typography>
      </div>
    </div>
  );
};

export default FeatureCard;
